<script setup>
    import {computed, onMounted} from "vue";
    import {trialListingStore} from "@pinia/trial-listing-store";
    import {toNumber} from "lodash";

    /**
     * Vue Components
     */
    import Loading from "@component/Loading/Loading.vue"
    import Trial from "@component/Trial/Trial.vue";
    import {getQueryParams} from "@util/api";
    import Program from "@component/Program/Program.vue";

    const {isHcps, resultsDefault, taId} = LISTING
    const {noResults, perPage} = resultsDefault;
    const store = trialListingStore()

    const loading = computed(() => store.loading)
    const results = computed(() => store.showResults)

    onMounted(() => {
        const queryParams = getQueryParams(new URL(window.location).search)

        store.taSearch({
            ppp: perPage || 5,
            page: queryParams?.pages || 1,
            taId: toNumber(taId),
            isHcps: !!isHcps,
            ...store.coords,
            ...queryParams
        }, false)
    })

</script>

<template>
    <div class="trials-body">
        <Loading
            :loading="loading"
        />

        <div v-if="results.length && !loading">
            <div
                v-for="trial in results"
                class="trial-row"
                :class="{'group-by-protocol': (trial.children && trial.children.length)}"
                :key="trial.id"
            >
                <Trial
                    v-if="trial.postType === 'trials'"
                    :trial="trial"
                />

                <Program
                    v-if="trial.postType === 'programs'"
                    :trial="trial"
                />

                <!-- Umbrella Protocol Trials -->
                <div
                    v-if="trial.children && trial.children.length"
                    class="sub-studies"
                    v-for="trial in trial.children"
                >
                    <Trial
                        v-if="trial.postType === 'trials'"
                        :trial="trial"
                    />

                    <Program
                        v-if="trial.postType === 'programs'"
                        :trial="trial"
                    />
                </div>
            </div>
        </div>

        <div
            v-else-if="!results.length && !loading"
            class="trial-result no-trials-found"
        >
            <div class="row">
                <div class="col-12">
                    <h3
                        class="no-trials-found__text"
                        v-html="noResults"
                    />
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Trial Listing"
    }
</script>

<style scoped lang="scss">

</style>
